<template>
    <v-card v-if="!loading.form" color="grey lighten-3">
        <v-tabs color="grey lighten-3" class="documents-tab" slider-color="primary" v-model="tab">
            <v-tab :key="1">
                {{newEmployee ? 'CREATE' : 'EDIT'}}
            </v-tab>
            <v-tab v-if="!newEmployee" :key="2">
                DOCUMENTS
            </v-tab>
            <v-tab v-if="!newEmployee" :key="3">
                TIME RECORDING
            </v-tab>
            <v-layout v-if="filePreviewMode" row class="text-xs-right document-actions">
                <v-flex xs12>
                    <v-btn icon @click="deleteDocument(-1)">
                        <v-icon color="grey">mdi-delete</v-icon>
                    </v-btn>
                    <v-btn @click="backToDocuments" color="primary" class="back-btn back-documents">Back</v-btn>
                </v-flex>
            </v-layout>
            <v-layout v-if="!filePreviewMode && tab == '1'" row class="text-xs-right document-actions">
                <v-flex xs12>
                    <v-btn @click="changeUploadModalVisibility(true)" color="primary" class="add-confirm-button">UPLOAD DOCUMENT
                        <v-icon class="upload-icon">mdi-cloud-upload</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
            <template v-if="tab==='1'">
                <v-layout v-if="filePreviewMode" row class="text-xs-right document-actions">
                    <v-flex xs12>
                        <v-btn :disabled="!isEditEnabled()" icon @click.stop.prevent="confirmDeleteSelectedDocument(-1)">
                            <v-icon color="grey">mdi-delete</v-icon>
                        </v-btn>
                        <v-btn @click="backToDocuments" color="primary" class="back-btn back-documents">Back</v-btn>
                    </v-flex>
                </v-layout>
                <v-layout v-else row class="text-xs-right document-actions">
                    <v-flex xs12>
                        <v-btn @click="changeUploadModalVisibility(true)" color="primary" class="add-confirm-button" >UPLOAD DOCUMENT
                            <v-icon class="upload-icon">mdi-cloud-upload</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </template>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item :key="1">
                <v-card-title class="employee-title" :class="{ 'employee-edit': !newEmployee }">

                    <div v-if="!newEmployee" class="employees-header employees-edit-header">Edit Employee
                        <v-tooltip bottom>
                            <v-btn v-show="!isSelfUser() && !isArchived()" flat icon color="black" slot="activator" @click="openArchiveModal()">
                                <v-icon color="red">mdi-package-down</v-icon>
                            </v-btn>
                            <span>Archive employee</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <v-btn v-show="!isSelfUser()" flat icon color="black" slot="activator" @click="employeeDelete()">
                                <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                            <span>Delete employee</span>
                        </v-tooltip>
                    </div>
                    <div v-else class="employees-header employees-add-header">Add Employee</div>
                    <div class="employees-header buttons-confirm-top">
                        <v-btn v-if="!newEmployee" @click="submit()" color="primary" class="add-confirm-button"
                            :loading="loading.saveButton" :disabled="loading.saveButton || loading.saveAndExitButton || !isEditEnabled()"
                        >Save</v-btn>
                        <v-btn v-if="!newEmployee" @click="submit(true)" color="primary" class="add-confirm-button"
                            :loading="loading.saveAndExitButton" :disabled="loading.saveButton || loading.saveAndExitButton || !isEditEnabled()"
                        >Save & Exit</v-btn>
                        <v-btn v-else @click="submit()" color="primary" class="add-confirm-button" :loading="creating" :disabled="creating">Create</v-btn>
                        <v-btn @click="goBack" color="primary" class="back-btn">Back</v-btn>
                    </div>

                </v-card-title>
                <v-card-text class="employees-text">
                    <v-form v-model="valid" ref="form" lazy-validation novalidate>
                        <EmployeeMainInfo v-bind:newEmployee="newEmployee" v-on:showGoogleError="isGoogleError(true)" />
                        <v-layout row class="roles-dep-wrapper">
                            <v-flex d-flex>
                                <EmployeeRole v-bind:tryValidate="this.tryValidate" />
                            </v-flex>
                            <v-flex d-flex>
                                <EmployeeDepartment v-bind:tryValidate="this.tryValidate" />
                            </v-flex>
                        </v-layout>
                        <EmployeeContactInfo />
                        <EmployeeEnglishLevel />
                        <EmployeeFacility />
                        <EmployeeBenefit />
                        <EmployeePosition />
                        <EmployeeSalaryHistory />
                        <div class="buttons-confirm">
                            <v-btn v-if="!newEmployee" @click="submit()" color="primary" class="add-confirm-button"
                                :loading="loading.saveButton" :disabled="loading.saveButton || loading.saveAndExitButton || !isEditEnabled()"
                            >Save</v-btn>
                            <v-btn v-if="!newEmployee" @click="submit(true)" color="primary" class="add-confirm-button"
                                :loading="loading.saveAndExitButton" :disabled="loading.saveButton || loading.saveAndExitButton || !isEditEnabled()"
                            >Save & Exit</v-btn>
                            <v-btn v-else @click="submit" color="primary" class="add-confirm-button" :loading="creating" :disabled="creating">Create</v-btn>
                            <v-btn @click="goBack" color="primary" class="back ml-0">Back</v-btn>
                        </div>
                    </v-form>
                    <modal-editor v-if='archiveModal' @confirm='archiveUserConfirm' @cancel='closeArchiveModal' :header="`Reason`"></modal-editor>
                    <information-dialog v-if="showInformationDialog" @ok="closeInformationDialog">
                        <v-card-title v-if="informationDialogContent.title" class="red--text" slot="title">
                            <b class="text-xs-center full-width">{{ informationDialogContent.title }}</b>
                        </v-card-title>
                        <v-card-title class="card-content" v-if="informationDialogContent.successText" slot="success-text">
                            <div class="text-xs-center full-width">{{ informationDialogContent.successText }}</div>
                            <b class="text-xs-center full-width">{{ informationDialogContent.successStatus }}</b>
                            <div v-if="informationDialogContent.googleAccountText" class="text-xs-center full-width">{{ informationDialogContent.googleAccountText }}</div>
                        </v-card-title>
                        <v-card-text v-if="informationDialogContent.errorText" class="red--text" slot="error-text">
                            <p class="text-xs-center full-width">{{ informationDialogContent.errorText }}</p>
                        </v-card-text>
                    </information-dialog>
                </v-card-text>
            </v-tab-item>

            <v-tab-item v-if="!newEmployee" :key="2">
                <template v-if="!filePreviewMode">
                    <v-data-table :headers="headers" :items="documents" class="elevation-1 documents-table" select-all v-model="selectedDocuments" :pagination.sync="pagination" item-key="name" :rows-per-page-items="[20, 50, 100, { text: 'All', value: -1 }]">

                        <template slot="headers" slot-scope="props">
                            <tr>
                                <th v-if="isEditEnabled()" class="select-cell">
                                    <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details @click.native="toggleAll"></v-checkbox>
                                </th>
                                <th v-for="header in props.headers" :key="header.text" :class="['column sortable', 'text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click="changeSort(header.value)">
                                    <v-icon small>arrow_upward</v-icon>
                                    {{ header.text }}
                                </th>
                                <th class="text-xs-left action-cell">
                                    <v-layout row class="document-options" align-center>
                                        <v-flex xs12>
                                            <v-btn :disabled="!isEditEnabled()" icon @click="confirmDeleteSelectedDocuments">
                                                <v-icon class="document-icon">mdi-delete</v-icon>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </th>
                            </tr>
                        </template>

                        <template slot="items" slot-scope="props">
                            <tr :active="props.selected">
                                <td v-if="isEditEnabled()" class="select-cell">
                                    <v-checkbox :input-value="props.selected" @click="props.selected = !props.selected" primary hide-details></v-checkbox>
                                </td>
                                <td class="text-xs-left">
                                    <v-icon class="document-type document-icon ext-doc">{{getFileIcon(props.item)}}</v-icon>
                                    {{props.item.name}}
                                </td>
                                <td class="document-value">{{ props.item.author.firstname + ' ' + props.item.author.lastname }}</td>
                                <td class="document-value">{{ formatSize(props.item.size) }}</td>
                                <td class="document-value">{{ formatDate(props.item.createdAt) }}</td>
                                <td class="action-cell">
                                    <v-layout row class="document-options" align-center>
                                        <v-flex xs4>
                                            <v-btn :disabled="!isEditEnabled()" icon @click="confirmDeleteSelectedDocument(props.item.id)">
                                                <v-icon class="document-icon">mdi-delete</v-icon>
                                            </v-btn>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-btn icon @click="saveDocument(props.item.uniqueName)">
                                                <v-icon class="document-icon">mdi-download</v-icon>
                                            </v-btn>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-btn icon @click="viewDocument(props.item)">
                                                <v-icon class="document-icon">mdi-eye</v-icon>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </td>
                            </tr>
                        </template>

                    </v-data-table>
                    <v-layout row>
                        <v-flex px-4 xs12 text-xs-right>
                            <v-btn @click="goBack" color="primary" class="back-btn back-documents">Back</v-btn>
                        </v-flex>
                    </v-layout>
                </template>
                <template v-else>
                    <div class="document-frame">
                        <iframe :src="currentFileLink" ref="documentFrame" frameborder="0"></iframe>
                    </div>
                </template>
            </v-tab-item>
            <v-tab-item v-if="!newEmployee" :key="3">
                <div class="employees-header buttons-confirm-top text-xs-right pr-2">
                    <v-btn @click="saveAddedVacations()" color="primary" class="add-confirm-button"
                        :loading="loading.saveAndExitButton" :disabled="loading.saveButton || loading.saveAndExitButton || !isEditEnabled()"
                    >Save</v-btn>
                    <v-btn @click="saveAddedVacations(true)" color="primary" class="add-confirm-button"
                        :loading="loading.saveAndExitButton" :disabled="loading.saveButton || loading.saveAndExitButton || !isEditEnabled()"
                    >Save & Exit</v-btn>
                    <v-btn @click="goBack" color="primary" class="back-btn">Back</v-btn>
                </div>
                <EmployeeSickLeave />
                <EmployeeVacation />
                <EmployeeTimeOff />
                <EmployeeMedicalLeave />
            </v-tab-item>

        </v-tabs-items>

        <v-dialog v-model="isEmployeeChangeNotSaved" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Confirmation required</v-card-title>
                <v-card-text>Are you sure you want to leave this page? Unsaved changes will be lost.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat @click.native="isEmployeeChangeNotSaved = false">Cancel</v-btn>
                    <v-btn color="green darken-1" flat @click.native="routeWithoutSave">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="uploadModal" persistent max-width="590">
            <v-card v-if="!filesUploading">
                <div class="files-dropzone">
                    <vue-dropzone ref="filesDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-file-added="fileAdded"></vue-dropzone>
                </div>
                <div class="preview__container pt-1">
                    <v-layout row wrap>
                        <template v-for="(file, id) in files">
                            <v-flex xs12 :key="id">
                                <v-layout row align-center>
                                    <v-flex xs1>
                                        <v-icon class="ext-doc">{{getFileIcon(file)}}</v-icon>
                                    </v-flex>
                                    <v-flex xs9 class="document-title">
                                        {{ file.name }}
                                    </v-flex>
                                    <v-flex xs2 class="document-icon">
                                        <v-layout row justify-end>
                                            <v-btn icon @click="confirmRemoveFileFromUploadList(id)">
                                                <v-icon color="grey">mdi-delete</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </template>
                    </v-layout>
                </div>
                <v-layout row align-center justify-end="">
                    <div class="text-xs-right btn-upload__container">
                        <v-btn @click="uploadFiles" color="primary" class="btn-upload">SAVE</v-btn>
                    </div>
                    <div class="text-xs-right btn-upload__container">
                        <v-btn @click="changeUploadModalVisibility(false)" color="primary" class="btn-upload">CLOSE</v-btn>
                    </div>
                </v-layout>
            </v-card>
            <v-card class="modal-uploader" v-else>
                <v-card-text class="progress-loading">
                    <v-progress-circular indeterminate v-bind:size="70" v-bind:width="7" color="indigo"></v-progress-circular>
                </v-card-text>
            </v-card>
        </v-dialog>

        <modal v-if="confirmDeleteDocumentsModal || confirmDeleteDocumentModal"
            @confirm="modalSubmitMethod" 
            @cancel='closeConfirmModal' 
            :confirmBtn="'Delete'"
            :header="`Are you sure you want to delete ${confirmDeleteDocumentsModal ? 'documents' : 'document'}?`">
        </modal>

        <modal v-if="confirmRemoveFileFromUploadListModal"
            @confirm="removeFileFromUploadList" 
            @cancel='closeConfirmModal' 
            :confirmBtn="'Delete'"
            :header="`Are you sure you want to delete this file?`">
        </modal>

    </v-card>
    <v-card-text v-else class="progress-loading">
        <v-progress-circular indeterminate v-bind:size="70" v-bind:width="7" color="indigo"></v-progress-circular>
    </v-card-text>
</template>
<script>
    import EmployeeContactInfo from '@/components/reusable/EmployeeContactInfo';
    import EmployeeDepartment from '@/components/reusable/EmployeeDepartment';
    import EmployeeEnglishLevel from '@/components/reusable/EmployeeEnglishLevel';
    import EmployeeFacility from '@/components/reusable/EmployeeFacility';
    import EmployeeBenefit from '@/components/reusable/EmployeeBenefit';
    import EmployeeMainInfo from '@/components/reusable/EmployeeMainInfo';
    import EmployeePosition from '@/components/reusable/EmployeePosition';
    import EmployeeRole from '@/components/reusable/EmployeeRole';
    import EmployeeSalaryHistory from '@/components/reusable/EmployeeSalaryHistory';
    import EmployeeVacation from '@/components/reusable/EmployeeVacation';
    import EmployeeSickLeave from '@/components/reusable/EmployeeSickLeave';
    import EmployeeTimeOff from '@/components/reusable/EmployeeTimeOff';
    import EmployeeMedicalLeave from '@/components/reusable/EmployeeMedicalLeave';
    import ModalEditorComponent from '@/components/common/modal-editor.component';
    import InformationDialog from '@/components/reusable/information-dialog';
    import ModalComponent from '@/components/common/modal.component';

    import vue2Dropzone from 'vue2-dropzone';
    import moment from 'moment';

    import {
        ADD_EMPLOYEE
    } from '@/store/modules/employees/mutation-types';
    import {
        mapGetters, mapActions
    } from 'vuex';

    export default {
        name: 'employee-edit',
        components: {
            EmployeeContactInfo,
            EmployeeDepartment,
            EmployeeEnglishLevel,
            EmployeeFacility,
            EmployeeBenefit,
            EmployeeMainInfo,
            EmployeePosition,
            EmployeeRole,
            EmployeeSalaryHistory,
            EmployeeVacation,
            EmployeeTimeOff,
            EmployeeSickLeave,
            EmployeeMedicalLeave,
            modalEditor: ModalEditorComponent,
            'information-dialog': InformationDialog,
            vueDropzone: vue2Dropzone,
            'modal': ModalComponent
        },
        data() {
            return {
                tab: '1',
                pagination: {
                    sortBy: 'name'
                },
                selectedDocuments: [],
                files: [],
                archiveModal: false,
                valid: false,
                tryValidate: false,
                showInformationDialog: false,
                loading: {
                    form: false,
                    saveButton: false,
                    saveAndExitButton: false
                },
                creating: false,
                saveExit: false,
                uploadModal: false,
                currentFileLink: '',
                informationDialogContent: {},
                initEmployee: {
                    employeeInfo: {},
                    employeeRoles: [],
                    employeeDepartments: [],
                    uploadingPhoto: null,
                    vacations: [],
                    timeOff: [],
                    sickLeaves: []
                },
                filesUploading: false,
                isEmployeeChangeNotSaved: false,
                routeTo: '',
                routeWithSaveConfirmed: false,
                newEmployee: false,
                headers: [{
                    text: 'Name',
                    value: 'name'
                },
                {
                    text: 'Author',
                    value: 'author'
                },
                {
                    text: 'Size',
                    value: 'size'
                },
                {
                    text: 'Created on',
                    value: 'created'
                }],
                dropzoneOptions: {
                    url: 'https://httpbin.org/post',
                    maxFilesize: 50,
                    dictDefaultMessage: 'Drop your files here (size limit: 40 MB per file)',
                    autoProcessQueue: false,
                    createImageThumbnails: false
                },
                filePreviewMode: false,
                selectedFileId: null,
                isUserDeleted: false,
                isUserArchived: false,
                deleteDocumentId: null,
                deleteFileId: null,
                confirmDeleteDocumentModal: false,
                confirmDeleteDocumentsModal: false,
                confirmRemoveFileFromUploadListModal: false
            };
        },
        created() {
            this.tab = 0;
            this.loading.form = true;
        },
        computed: mapGetters({
            employee: 'getEmployee',
            roles: 'getRoles',
            departments: 'getDepartments',
            uploadingPhoto: 'getUploadingPhoto',
            user: 'getUser',
            documents: 'getDocuments',
            allMedicalLeaves: 'getAllMedicalLeaves',
            allVacations: 'getAllVacations',
            allTimeOff: 'getAllTimeOff',
            allSickLeaves: 'getAllSickLeaves',
            addedVacations: 'getAddedVacations',
            addedSickLeaves: 'getAddedSickLeaves',
            addedTimeOff: 'getAddedTimeOff',
            addedMedicalLeaves: 'getAddedMedicalLeaves',
            selectedVacations: 'getSelectedVacations',
            selectedSickLeaves: 'getSelectedSickLeaves',
            selectedTimeOff: 'getSelectedTimeOff',
            selectedMedicalLeaves: 'getSelectedMedicalLeaves',
            googleAccountInfo: 'getGoogleAccountInfo'
        }),
        beforeRouteLeave(to, from, next) {
            to.params.employeeId = this.isUserDeleted || this.isUserArchived ? null : this.employee.userId;
            if (this.$route.name === 'EmployeeEdit' || this.$route.name === 'EmployeeArchiveEdit') {
                this.routeWithSaveConfirmed && next();
                if (this.initEmployee.employeeInfo !== JSON.stringify(this.employee) ||
                    this.initEmployee.employeeRoles !== JSON.stringify(this.roles) ||
                    this.initEmployee.employeeDepartments !== JSON.stringify(this.departments) ||
                    this.initEmployee.uploadingPhoto !== this.uploadingPhoto ||
                    this.initEmployee.vacations !== JSON.stringify(this.allVacations) ||
                    this.initEmployee.timeOff !== JSON.stringify(this.allTimeOff) ||
                    this.initEmployee.sickLeaves !== JSON.stringify(this.allSickLeaves)) {
                    this.isEmployeeChangeNotSaved = true;
                } else {
                    next();
                }
                this.routeTo = to.path;
            } else {
                next();
            }
        },
        beforeRouteEnter: (to, from, next) => {
            next(vm => {
                vm.initEmployeeView();
            });
        },
        methods: {
            ...mapActions([
                'saveVacations',
                'saveTimeOff',
                'saveSickLeaves',
                'saveMedicalLeaves',
                'deleteVacations',
                'deleteSickLeaves',
                'deleteTimeOff',
                'deleteMedicalLeaves',
                'clearAllVacations',
                'fetchEmpoyeesByRole',
                'deleteEmployee',
                'fetchFacilityTypes',
                'fetchFacilityDevices',
                'fetchBenefits',
                'fetchHolidays',
                'fetchEmployee',
                'fetchRoles',
                'fetchDepartments',
                'fetchDocuments',
                'fetchVacations',
                'downloadDocument'
            ]),
            initEmployeeView() {
                this.loading.form = true;
                if (this.$route.name === 'EmployeeEdit' || this.$route.name === 'EmployeeArchiveEdit') {
                    const employeeId = this.$route.params.userId;
                    Promise.all([
                        this.fetchEmployee(employeeId),
                        this.fetchEmpoyeesByRole('coordinator'),
                        this.fetchEmpoyeesByRole('director'),
                        this.fetchDocuments(employeeId),
                        this.fetchVacations(employeeId),
                        this.fetchHolidays(),
                        this.fetchFacilityTypes(),
                        this.fetchFacilityDevices(),
                        this.fetchBenefits()
                    ]).then(() => {
                        Promise.all([
                            this.fetchRoles(),
                            this.fetchDepartments()
                        ]).then(() => {
                            document.title = `${this.employee.firstname} ${this.employee.lastname} | ${this.$route.meta.title}`;
                            this.saveEmployeeState();
                            this.loading.form = false;
                        }, error => {
                            this.loading.form = false;
                        });
                    }, error => {
                        this.loading.form = false;
                    });
                } else if (this.$route.name === 'EmployeeAddNew') {
                    this.newEmployee = true;
                    this.$store.commit(ADD_EMPLOYEE);
                    this.$store.dispatch('fetchRoles').then(res => {
                        this.$store.dispatch('fetchDepartments').then(res => {
                            Promise.all([
                                this.fetchEmpoyeesByRole('coordinator'),
                                this.fetchEmpoyeesByRole('director'),
                                this.fetchFacilityTypes(),
                                this.fetchFacilityDevices(),
                                this.fetchBenefits()
                            ])
                            .then(res => {
                                this.loading.form = false;
                                this.initEmployee.employeeInfo = this.employee;
                            }, error => {
                                this.loading.form = false;
                            });
                        }, error => {
                            this.loading.form = false;
                        });
                    }, error => {
                        this.loading.form = false;
                    });
                }
            },
            submit(exit = false) {
                this.saveExit = exit;
                this.tryValidate = true;
                this.$refs.form.watchInputs();
                const checkedRoles = this.roles.filter(x => x.checked);
                const checkedDepartments = this.departments.filter(x => x.checked);

                if (this.$refs.form.validate() && checkedRoles.length &&
                    checkedDepartments.length) {
                    if (this.$route.name === 'EmployeeEdit' || this.$route.name === 'EmployeeArchiveEdit') {
                        this.updateButtonsLoadingStatuses(true);
                    } else if (this.$route.name === 'EmployeeAddNew') {
                        this.creating = true;
                    }
                    this.$store.dispatch('mapRoles', checkedRoles);
                    this.$store.dispatch('mapDepartments', checkedDepartments);
                    if (this.$route.name === 'EmployeeEdit' || this.$route.name === 'EmployeeArchiveEdit') {
                        if (this.uploadingPhoto) {
                            this.uploadPhotoAndSave();
                        } else {
                            this.saveEmployee();
                        }
                    } else if (this.$route.name === 'EmployeeAddNew') {
                        if (this.uploadingPhoto) {
                            this.uploadPhotoAndSave();
                        } else {
                            this.createEmployee();
                        }
                    }
                } else {
                    window.scrollTo(0, 0);
                }
            },
            uploadPhotoAndSave() {
                this.$store.dispatch('uploadPhoto', this.uploadingPhoto).then(res => {
                    this.$store.dispatch('editEmployeePhotoUrl', res.body).then(res => {
                        if (this.$route.name === 'EmployeeEdit' || this.$route.name === 'EmployeeArchiveEdit') {
                            this.saveEmployee();
                        } else if (this.$route.name === 'EmployeeAddNew') {
                            this.createEmployee();
                        }
                    }, error => {
                        this.showInformationDialog = true;
                        this.updateButtonsLoadingStatuses(false);
                        this.informationDialogContent = {
                            title: 'Error',
                            errorText: 'Can\'t edit the photo url'
                        };
                    });
                }, error => {
                    this.showInformationDialog = true;
                    this.updateButtonsLoadingStatuses(false);
                    this.informationDialogContent = {
                        title: 'Error',
                        errorText: 'Can\'t upload the photo'
                    };
                });
            },
            saveEmployee() {
                this.$store.dispatch('editEmployee', this.employee).then(result => {
                    this.saveEmployeeState();
                    this.updateButtonsLoadingStatuses(false);
                    this.informationDialogContent = {
                        successText: 'Changes have been successfully',
                        successStatus: 'Saved',
                        googleAccountText: this.employee.createGoogleAccount ? this.getGoogleAccountMessage(result, 'updated') : 'The email has been linked to an existing Google account.'
                    };
                    if (this.saveExit) {
                        this.informationDialogContent.callback = () => {
                            this.goBack();
                        };
                    }
                    this.showInformationDialog = true;
                }, error => {
                    this.updateButtonsLoadingStatuses(false);
                    this.informationDialogContent = {
                        title: 'Error',
                        errorText: 'A user with this email already exists.'
                    };
                    this.showInformationDialog = true;
                });
            },
            createEmployee() {
                this.$store.dispatch('addNewEmployee', this.employee).then(res => {
                    this.creating = false;
                    this.informationDialogContent = {
                        successText: 'User has been successfully',
                        successStatus: 'Created',
                        googleAccountText: this.employee.createGoogleAccount ? this.getGoogleAccountMessage(res, 'created') : 'The email has been linked to an existing Google account.',
                        callback: () => {
                            this.$router.push('/employees');
                        }
                    };
                    this.showInformationDialog = true;
                }, error => {
                    this.showInformationDialog = true;
                    this.informationDialogContent = {
                        title: 'Error',
                        errorText: 'A user with this email already exists.'
                    };
                    this.creating = false;
                });
            },
            goBack() {
                const currentRouterName = this.$router.history.current.name;
                this.$router.push({
                    name: (currentRouterName === 'EmployeeEdit' || currentRouterName === 'EmployeeAddNew')
                        ? 'Employees'
                        : 'Archive',
                    params: {
                        listItems: this.$router.history.current.query.items,
                        listPage: this.$router.history.current.query.page,
                        employeeId: this.employee.userId
                    }
                });
            },
            openArchiveModal() {
                this.archiveModal = true;
            },
            closeArchiveModal() {
                this.archiveModal = false;
            },
            archiveUserConfirm(archivationReason, terminationDate) {
                this.archiveModal = false;
                const id = this.$route.params.userId;
                this.$store.dispatch('archiveEmployee', { id, archivationReason, terminationDate }).then(res => {
                    this.informationDialogContent = {
                        successText: 'User has been successfully',
                        successStatus: 'Archived',
                        googleAccountText: this.getGoogleAccountMessage(res, 'archived'),
                        callback: () => {
                            this.isUserArchived = true;
                            this.$router.push('/employees');
                        }
                    };

                    this.showInformationDialog = true;
                });
            },
            isSelfUser() {
                return this.$route.params.userId === this.$store.state.user.user.UserId;
            },
            isArchived() {
                return this.employee.archived;
            },
            closeInformationDialog() {
                this.showInformationDialog = false;
                if (typeof this.informationDialogContent.callback === 'function') {
                    this.informationDialogContent.callback.call(this);
                }
            },
            routeWithoutSave() {
                this.isEmployeeChangeNotSaved = false;
                this.routeWithSaveConfirmed = true;
                this.clearAllVacations();
                this.$router.push(this.routeTo);
            },
            saveEmployeeState() {
                this.initEmployee.employeeRoles = JSON.stringify(this.roles);
                this.initEmployee.employeeDepartments = JSON.stringify(this.departments);
                this.initEmployee.employeeInfo = JSON.stringify(this.employee);
                this.initEmployee.uploadingPhoto = this.uploadingPhoto;
                this.initEmployee.medicalLeaves = JSON.stringify(this.allMedicalLeaves);
                this.initEmployee.vacations = JSON.stringify(this.allVacations);
                this.initEmployee.timeOff = JSON.stringify(this.allTimeOff);
                this.initEmployee.sickLeaves = JSON.stringify(this.allSickLeaves);
            },

            saveMedicalLeavesState() {
                this.initEmployee.medicalLeaves = JSON.stringify(this.allMedicalLeaves);
            },

            saveVacationsState() {
                this.initEmployee.vacations = JSON.stringify(this.allVacations);
            },

            saveTimeOffState() {
                this.initEmployee.timeOff = JSON.stringify(this.allTimeOff);
            },

            saveSickLeavesState() {
                this.initEmployee.sickLeaves = JSON.stringify(this.allSickLeaves);
            },

            toggleAll() {
                if (this.selectedDocuments.length) {
                    this.selectedDocuments = [];
                } else if (this.documents.length) {
                    this.selectedDocuments = this.documents.slice();
                }
            },
            changeSort(column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending;
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false;
                }
            },
            uploadFiles() {
                if (this.files.length > 0) {
                    this.filesUploading = true;
                    let form = new FormData();
                    this.files.forEach(file => {
                        form.append('file', file, file.name);
                    });
                    form.append('EmployeeId', this.employee.userId);
                    form.append('AuthorId', this.user.UserId);
                    this.$store.dispatch('uploadDocuments', form).then(() => {
                        this.$store.dispatch('fetchDocuments',
                        this.employee.userId).then(() => {
                            this.filesUploading = false;
                            this.files = [];
                            this.uploadModal = false;
                        });
                    });
                } else {
                    this.uploadModal = false;
                }
            },
            changeUploadModalVisibility(show) {
                this.uploadModal = show;
            },
            fileAdded(file) {
                let fileCanBeAdded = true;
                this.$refs.filesDropzone.removeAllFiles();

                if (this.documents.some(d => d.name === file.name)) {
                    fileCanBeAdded = false;
                    this.informationDialogContent = {
                        errorText: `File with name ${file.name} already added`
                    };
                } else {
                    if (this.files.some(d => d.name === file.name)) {
                        fileCanBeAdded = false;
                        this.informationDialogContent = {
                            errorText: `File with name ${file.name} already uploaded`
                        };
                    }
                }

                if (fileCanBeAdded) {
                    this.files.push(file);
                } else {
                    this.showInformationDialog = true;
                }
            },
            confirmRemoveFileFromUploadList(fileIndex) {
                this.deleteFileId = fileIndex;
                this.confirmRemoveFileFromUploadListModal = true;
            },
            removeFileFromUploadList() {
                this.files.splice(this.deleteFileId, 1);
                this.confirmRemoveFileFromUploadListModal = false;
            },
            formatDate(date) {
                return moment(date).format('DD.MM.YYYY');
            },
            saveDocument(fileName) {
                this.downloadDocument(fileName);
            },
            viewDocument(file) {
                const url = `${process.env.API}/documents/${file.uniqueName}`;
                this.currentFileLink = `https://docs.google.com/gview?url=${url}&embedded=true`;
                this.filePreviewMode = true;
                this.selectedFileId = file.id;
            },
            deleteDocument() {
                const docId = (this.deleteDocumentId === -1)
                    ? this.selectedFileId
                    : this.deleteDocumentId;
                this.$store.dispatch('deleteDocuments', [docId]).then(() => {
                    this.filePreviewMode = false;
                    this.confirmDeleteDocumentModal = false;
                    this.deleteDocumentId = null;
                });
            },
            formatSize(size) {
                switch (true) {
                    case (size < 1024):
                        return `${size.toFixed(2)} B`;
                    case (size < Math.pow(1024, 2)):
                        return `${(size / 1024).toFixed(2)} KB`;
                    case size < Math.pow(1024, 3):
                        return `${(size / Math.pow(1024, 2)).toFixed(2)} MB`;
                    default:
                        return `${(size / Math.pow(1024, 3)).toFixed(2)} GB`;
                }
            },
            deleteSelectedDocuments() {
                if (this.selectedDocuments.length) {
                    this.$store.dispatch('deleteDocuments', this.selectedDocuments.map(x => x.id)).then(() => {
                        this.selectedDocuments = [];
                        this.confirmDeleteDocumentsModal = false;
                    });
                }
            },
            backToDocuments() {
                this.filePreviewMode = false;
            },
            getExtension(fileName) {
                return fileName.substr(fileName.lastIndexOf('.'));
            },
            updateButtonsLoadingStatuses(status) {
                if (this.saveExit) {
                    this.loading.saveAndExitButton = status;
                } else {
                    this.loading.saveButton = status;
                }
            },
            getGoogleAccountMessage(isSuccess, action) {
                return isSuccess ? `Google account has been ${action} successfully.` : (isSuccess !== null ? `Google account has not been ${action}.` : '');
            },
            saveAddedVacations(saveExit) {
                this.informationDialogContent = {
                    successText: 'Changes have been successfully',
                    successStatus: 'Saved'
                };
                if (this.addedVacations.length) {
                    this.saveVacations(this.addedVacations).then(() => {
                        this.saveVacationsState();
                    }, error => {
                        this.informationDialogContent = {
                            title: 'Error',
                            errorText: 'Something went wrong'
                        };
                    });
                }

                if (this.selectedVacations.length) {
                    this.deleteVacations(this.selectedVacations).then(() => this.saveVacationsState());
                }

                if (this.addedSickLeaves.length) {
                    this.saveSickLeaves(this.addedSickLeaves).then(() => {
                        this.saveSickLeavesState();
                    }, error => {
                        this.informationDialogContent = {
                            title: 'Error',
                            errorText: 'Something went wrong'
                        };
                    });
                }

                if (this.selectedSickLeaves.length) {
                    this.deleteSickLeaves(this.selectedSickLeaves).then(() => this.saveSickLeavesState());
                }

                if (this.addedTimeOff.length) {
                    this.saveTimeOff(this.addedTimeOff).then(() => {
                        this.saveTimeOffState();
                    }, error => {
                        this.informationDialogContent = {
                            title: 'Error',
                            errorText: 'Something went wrong'
                        };
                    });
                }

                if (this.selectedTimeOff.length) {
                    this.deleteTimeOff(this.selectedTimeOff).then(() => this.saveTimeOffState());
                }

                if (this.addedMedicalLeaves.length) {
                    this.saveMedicalLeaves(this.addedMedicalLeaves).then(() => {
                        this.saveMedicalLeavesState();
                    }, error => {
                        this.informationDialogContent = {
                            title: 'Error',
                            errorText: 'Something went wrong'
                        };
                    });
                }

                if (this.selectedMedicalLeaves.length) {
                    this.deleteMedicalLeaves(this.selectedMedicalLeaves).then(() => this.saveMedicalLeavesState());
                }

                if (saveExit) {
                    this.informationDialogContent.callback = this.goBack;
                }

                this.showInformationDialog = true;
            },
            getFileIcon(file) {
                if (!file.extension) {
                    file.extension = `.${file.name.split('.').pop()}`;
                }
                switch (file.extension) {
                    case '.xlsx':
                    case '.xls':
                        return 'mdi-file-excel';
                    case '.docx':
                    case '.doc':
                        return 'mdi-file-word';
                    case '.txt':
                        return 'mdi-file-document';
                    case '.pdf':
                        return 'mdi-file-pdf';
                    case '.ppt':
                    case '.pptx':
                        return 'mdi-file-powerpoint';
                    case '.png':
                    case '.jpg':
                    case '.jpeg':
                        return 'mdi-file-image';
                    case '.mp4':
                    case '.webm':
                    case '.avi':
                        return 'mdi-file-video';
                    case '.rar':
                    case '.zip':
                    case '.7z':
                        return 'mdi-zip-box';
                }
            },
            isGoogleError(googleServiceError) {
                let error = '';
                if (googleServiceError || this.googleAccountInfo.isError) {
                    error = 'Google integration is not configured. Please, contact administrator.';
                } else if (this.googleAccountInfo.isExist) {
                    error = this.employee.createGoogleAccount ? 'Google account with this email already exists.'
                        : this.googleAccountInfo.isDeleted ? 'Google account is created but is blocked. Please, contact administrator.' : '';
                }

                if (error) {
                    this.showInformationDialog = true;
                    this.informationDialogContent = {
                        title: 'Error',
                        errorText: error
                    };
                    this.creating = false;

                    return true;
                }

                return false;
            },
            isEditEnabled() {
                return !this.employee.archived && !this.loading.form;
            },
            confirmDeleteSelectedDocuments() {
                if (this.selectedDocuments.length) {
                    this.confirmDeleteDocumentsModal = true;
                }
            },
            confirmDeleteSelectedDocument(documentId) {
                this.deleteDocumentId = documentId;
                this.confirmDeleteDocumentModal = true;
            },
            closeConfirmModal() {
                this.confirmDeleteDocumentModal = false;
                this.confirmDeleteDocumentsModal = false;
                this.confirmRemoveFileFromUploadListModal = false;
            },
            modalSubmitMethod() {
                this.confirmDeleteDocumentModal ? this.deleteDocument() : this.deleteSelectedDocuments();
            },
            employeeDelete() {
                this.deleteEmployee(this.employee.userId);
                this.$router.push('/');
            }
        }
    };
</script>
<style scoped>
.buttons-confirm-top .btn {
  min-width: 120px;
}

.back-btn {
  background-color: #3f51b5 !important;
}

.buttons-confirm {
  margin-top: 25px;
}

.employees-header {
  font-size: 24px;
}

.employees-edit-header {
  padding-left: 13px;
}

.employees-add-header {
  padding-left: 11px;
}

.full-width {
  width: 100%;
}

.documents-table {
  margin: 20px 32px 20px;
}

.document-icon {
  font-size: 20px;
  color: #757575 !important;
}

.document-type {
  padding-right: 12px;
}

.select-cell {
  padding: 10 !important;
  max-width: 30px;
}

.documents-tab {
  padding-left: 24px;
}

.tabs__div {
  font-size: 16px !important;
}

.document-actions {
  position: absolute;
  right: 0;
  top: 5px;
  padding-right: 24px;
}

.upload-icon {
  color: white;

  padding-left: 18px;
}

.files-dropzone {
  padding: 20px 20px 10px 20px;
}

.files-dropzone > .vue-dropzone {
  min-height: 260px;
  border: 3px dashed #e5e5e5 !important;
}

.files-dropzone >>> .dz-default {
  margin: 110px !important;
}

.btn-upload__container {
  padding: 10px;
}

.btn-upload {
  width: 70px;
}

.dropzone {
  padding: 0px !important;
}

.preview__container {
  padding: 0px 20px 0px;
}

.document-title {
  font-size: 16px;
}

.modal-uploader {
  height: 362px !important;
}

.action-cell {
  width: 10%;
}

.document-value {
  padding-left: 40px !important;
}

.ext-doc {
  color: #2d9cdb !important;
}

.document-frame {
  padding-top: 10px;
  width: 810px;
  margin: 0 auto;
  height: 760px;
}

.document-frame > iframe {
  width: 100%;
  height: 100%;
}

.card-content *:not(:last-child) {
  padding-bottom: 16px;
}

@media screen and (max-width: 600px) {
  .layout.row {
    flex-direction: column;
  }
  .ma-2.card-checkbox.card {
    margin: 7px !important;
  }
  .employees-header {
    padding-left: 7px;
  }
  .add-confirm-button {
    margin-right: 7px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Employee.vue